import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/v2/lib/utils";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
	path: string;
	label: string;
	icon: LucideIcon;
}

interface MobileBottomNavProps {
	items: NavItem[];
}

export function MobileBottomNav({ items }: MobileBottomNavProps) {
	const location = useLocation();
	const navigate = useNavigate();

	return (
		<nav className="shrink-0 border-t border-border bg-background pb-[env(safe-area-inset-bottom)]">
			<div className="flex h-16 items-center justify-around">
				{items.map((item) => {
					const isActive = location.pathname.startsWith(item.path);
					return (
						<button
							key={item.path}
							onClick={() => navigate(item.path + location.search)}
							className={cn(
								"flex flex-col items-center justify-center gap-1 min-w-[64px] min-h-[44px] px-3",
								isActive ? "text-primary" : "text-muted-foreground",
							)}
						>
							<item.icon className="size-5" />
							<span className="text-[11px] font-medium leading-none">
								{item.label}
							</span>
						</button>
					);
				})}
			</div>
		</nav>
	);
}
